import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const redirectLocation = sessionStorage.getItem('redirectLocation');
    if (redirectLocation) {
      console.log('redirecting to', redirectLocation);
      sessionStorage.removeItem('redirectLocation');
      // The dashboard entry only existed to do this redirect, so it must not stay in the history
      navigate(redirectLocation, { replace: true });
    }
  }, [navigate]);
};

export default useRedirect;
